  varying vec3 vWorldNormal;
  void main() {
    gl_FragColor.rgb = vWorldNormal;
  }